import { Container } from '../ui/Container';

interface Stat {
  number: string;
  unit?: string;
  label: string;
  body: string;
}

const stats: Stat[] = [
  {
    number: '45',
    label: 'Owner-occupied homes',
    body: 'Five stories. Thirty-five two-bedroom and ten three-bedroom units. Standing since 1983.',
  },
  {
    number: '30',
    unit: 'K acres',
    label: 'Banana River Aquatic Preserve',
    body: 'Protected estuary along our seawall. Manatees and dolphins from our dock year round.',
  },
  {
    number: '2',
    unit: 'blocks',
    label: 'To the Atlantic',
    body: 'Walk to the ocean. Fifteen miles to Kennedy Space Center, one hour to Orlando.',
  },
];

export function MarqueeFacts(): JSX.Element {
  return (
    <section
      id="marquee"
      className="relative isolate overflow-hidden bg-brand-charcoal text-brand-white"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-10 bg-gradient-to-br from-brand-charcoal via-brand-charcoal to-brand-black"
      />
      <div
        aria-hidden="true"
        className="absolute -right-32 -top-32 -z-10 h-96 w-96 rounded-full bg-brand-yellow/10 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="absolute -left-32 -bottom-32 -z-10 h-96 w-96 rounded-full bg-brand-yellow/5 blur-3xl"
      />

      <Container className="py-20 md:py-24">
        <div className="grid gap-12 md:grid-cols-3 md:gap-10">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`flex flex-col ${i > 0 ? 'md:border-l md:border-white/10 md:pl-10' : ''}`}
            >
              <p className="font-bold leading-none tracking-tight text-brand-yellow">
                <span className="text-7xl md:text-8xl">{s.number}</span>
                {s.unit ? (
                  <span className="ml-2 text-2xl font-semibold text-brand-yellow/70 md:text-3xl">
                    {s.unit}
                  </span>
                ) : null}
              </p>
              <p className="mt-5 text-base font-semibold uppercase tracking-[0.18em] text-brand-yellow">
                {s.label}
              </p>
              <p className="mt-4 text-base leading-relaxed text-brand-white/80">{s.body}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
